"use strict";

var aminoAcidToDegenerateDnaMap = require("./aminoAcidToDegenerateDnaMap");

module.exports = function getDegenerateDnaStringFromAAString(aaString) {
  return aaString.split("").map(function (char) {
    return aminoAcidToDegenerateDnaMap[char.toLowerCase()] || "nnn";
  }).join("");
};